import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertCircle } from 'lucide-react';

const DeleteRecurringDialog = ({ open, onClose, onDelete }) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md" data-testid="delete-recurring-dialog">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold flex items-center gap-2">
            <AlertCircle className="h-6 w-6 text-orange-500" />
            Supprimer l'opération récurrente
          </DialogTitle>
          <DialogDescription>
            Cette opération fait partie d'une série récurrente. Que souhaitez-vous supprimer ?
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 mt-4">
          <Button
            onClick={() => onDelete('this_only')}
            variant="outline"
            className="w-full justify-start text-left h-auto py-4 px-4"
            data-testid="delete-this-only"
          >
            <div>
              <div className="font-semibold mb-1">Seulement cette occurrence</div>
              <div className="text-xs text-gray-500">Supprime uniquement cette opération, les autres sont conservées</div>
            </div>
          </Button>

          <Button
            onClick={() => onDelete('future')}
            variant="outline"
            className="w-full justify-start text-left h-auto py-4 px-4"
            data-testid="delete-future"
          >
            <div>
              <div className="font-semibold mb-1">Cette occurrence et les suivantes</div>
              <div className="text-xs text-gray-500">Supprime cette opération et toutes les futures occurrences</div>
            </div>
          </Button>

          <Button
            onClick={() => onDelete('all')}
            variant="outline"
            className="w-full justify-start text-left h-auto py-4 px-4 border-red-200 hover:bg-red-50"
            data-testid="delete-all"
          >
            <div>
              <div className="font-semibold mb-1 text-red-600">Toute la série</div>
              <div className="text-xs text-gray-500">Supprime toutes les occurrences (passées et futures)</div>
            </div>
          </Button>

          <Button
            onClick={onClose}
            variant="ghost"
            className="w-full"
            data-testid="cancel-delete"
          >
            Annuler
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteRecurringDialog;